import { Link } from "react-router-dom";
import { KeyRound, MessageCircle, Phone, ArrowLeft, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";

// Admin-assisted password reset. Self-serve recovery has been removed;
// users must contact the PM Poshan admin to have their password reset.
const ADMIN_MOBILE = "8093414633";
const WA_LINK = `https://wa.me/91${ADMIN_MOBILE}?text=${encodeURIComponent(
  "Hi PM Poshan admin, I forgot my password. My registered mobile is ______. Please reset it."
)}`;

export default function ForgotPassword() {
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="forgot-page">
      <div>
        <div className="chip chip-green"><KeyRound size={14}/> Forgot password</div>
        <h1 className="mt-2 font-display text-3xl font-extrabold text-slate-900">Reset with admin help</h1>
        <p className="mt-1 text-slate-600">
          For your safety, PM Poshan passwords are reset by our admin team. Reach out on WhatsApp or call —
          we typically reply within a few working hours.
        </p>
      </div>

      <div className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50/40 p-6 space-y-5" data-testid="forgot-admin-card">
        <div className="flex items-start gap-3">
          <span className="h-10 w-10 rounded-lg bg-emerald-700 text-white grid place-items-center shrink-0"><ShieldCheck size={18}/></span>
          <div>
            <h2 className="font-display font-bold text-lg text-slate-900">Contact the PM Poshan admin</h2>
            <p className="text-sm text-slate-700">
              Please share your <b>registered 10-digit mobile number</b> and, if possible, your <b>UDISE code</b>.
              The admin will verify and send you a fresh temporary password.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-3">
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer" data-testid="forgot-whatsapp">
            <Button className="w-full h-12 bg-emerald-600 hover:bg-emerald-700 text-white font-bold">
              <MessageCircle size={18}/> WhatsApp Admin
            </Button>
          </a>
          <a href={`tel:+91${ADMIN_MOBILE}`} data-testid="forgot-call">
            <Button variant="outline" className="w-full h-12 border-emerald-300 text-emerald-800 hover:bg-emerald-50 font-bold">
              <Phone size={18}/> Call +91 {ADMIN_MOBILE}
            </Button>
          </a>
        </div>

        <div className="rounded-lg bg-white border border-slate-200 p-3 text-xs text-slate-600">
          <b>Tip:</b> If you set a lucky number and avatar during signup, mention them to the admin as an extra
          identity check. They&rsquo;ll never ask for your current password.
        </div>
      </div>

      <div className="mt-6 flex flex-wrap items-center gap-3">
        <Link to="/login" data-testid="forgot-to-login">
          <Button variant="outline"><ArrowLeft size={14}/> Back to Sign in</Button>
        </Link>
        <span className="text-sm text-slate-600">
          Don&rsquo;t have an account?{" "}
          <Link to="/register" className="text-emerald-700 font-semibold hover:underline">Create one free</Link>
        </span>
      </div>
    </div>
  );
}
